<template>
  <div class="Others32Charts" :class="getStyle('title')">
    <div class="weather-card">
      <!-- 顶部核心天气信息 -->
      <div
        class="top-section"
        :style="{
          marginBottom: `${$w_Ratio(1 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <div class="sun-icon">
          <img
            :style="{
              width: `${$w_Ratio(40 + getShowfontSizeBase(), $store)}px`,
            }"
            :src="require(`../../../assets/img/weather/${getNoWeatherIcon(weatherIcon)}.png`)"
            alt=""
          />
        </div>
        <div
          class="temperature"
          :style="{
            fontSize: `${$w_Ratio(14 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          {{ currTemperature }}°C
        </div>
        <div class="weather-status">
          <div class="weather-info">
            <div
              :style="{
                fontSize: `${$w_Ratio(4 + getShowfontSizeBase(), $store)}px`,
              }"
            >
              {{ weatherText }}
            </div>
          </div>
        </div>
        <div
          class="comfort-level"
          :style="{
            padding: `${$w_Ratio(-8 + getShowfontSizeBase(), $store)}px ${$w_Ratio(
              4 + getShowfontSizeBase(),
              $store,
            )}px`,
            fontSize: `${$w_Ratio(2 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          较舒适
        </div>
      </div>
      <!-- 分割线 -->
      <div class="divider">
        <img src="@/assets/img/weather/weato.png" alt="" />
        <img src="@/assets/img/weather/weabo.png" alt="" />
      </div>
      <!-- 底部实时气象数据区 -->
      <div
        class="bottom-section"
        :style="{
          marginTop: `${$w_Ratio(1 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <div
          class="section-title"
          :style="{
            fontSize: `${$w_Ratio(5 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          {{ meteorologicalTitle }}
        </div>
        <div class="data-item">
          <img src="@/assets/img/weather/wd.png" alt="" />
          <span class="label" :style="getFontSize(3)">{{ temperatureTitle }}</span>
          <span class="value" :style="getFontSize(5)">{{ temperature }}°C</span>
        </div>
        <div class="data-item">
          <img src="@/assets/img/weather/sd2.png" alt="" />
          <span class="label" :style="getFontSize(2)">湿度</span>
          <span class="value" :style="getFontSize(2)">{{ humidity }}%</span>
        </div>
        <div class="data-item">
          <img src="@/assets/img/weather/js.png" alt="" />
          <span class="label" :style="getFontSize(2)">降水</span>
          <span class="value" :style="getFontSize(2)">{{ precipitation }}mm</span>
        </div>
        <div class="data-item">
          <img src="@/assets/img/weather/qy.png" alt="" />
          <span class="label" :style="getFontSize(2)">气压</span>
          <span class="value" :style="getFontSize(2)">{{ hPa }}hPa</span>
        </div>
        <div class="data-item">
          <img src="@/assets/img/weather/pm.png" alt="" />
          <span class="label" :style="getFontSize(2)">PM2.5</span>
          <span class="value" :style="getFontSize(2)">{{ pm2point5 }}%</span>
        </div>
        <div class="data-item">
          <img src="@/assets/img/weather/fl.png" alt="" />
          <span class="label" :style="getFontSize(2)">风力</span>
          <span class="value" :style="getFontSize(2)">{{ windpower }}级</span>
        </div>
        <div class="data-item">
          <img src="@/assets/img/weather/fylz.png" alt="" />
          <span class="label" :style="getFontSize(2)">负氧离子</span>
          <span class="value" :style="getFontSize(2)">{{ oxygen }}/cm³</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Others32Charts',
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      headerLon: '',
      headerLat: '',
      weatherIcon: '',
      weatherText: '晴',
      currTemperature: 0,
      weather: '', // 当前天气
      temperature: '', // 当前温度
      humidity: '', // 湿度
      winddirection: '', // 风向
      windpower: '', // 风力
      oxygen: 0, // 负氧离子
      hPa: '', // 气压
      precipitation: '0.00', // 降水
      pm2point5: '0', // PM2.5
      meteorologicalTitle: '天坛峰实时气象数据',
      temperatureTitle: '山顶温度',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
        this.headerLon = val.propertyData.headerLngLatData.value.lon;
        this.headerLat = val.propertyData.headerLngLatData.value.lat;
        this.meteorologicalTitle = val.propertyData.leftSubtitle?.value;
        this.temperatureTitle = val.propertyData.rightSubtitle?.value;
      },
    },
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
    isLargeScreen() {
      return window.innerWidth > 2000;
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);

    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    this.headerLon = this.Configuration.propertyData?.headerLngLatData?.value?.lon;
    this.headerLat = this.Configuration.propertyData?.headerLngLatData?.value?.lat;
    this.meteorologicalTitle = this.Configuration.propertyData?.leftSubtitle?.value;
    this.temperatureTitle = this.Configuration.propertyData?.rightSubtitle?.value;

    // 添加窗口大小变化监听器
    window.addEventListener('resize', this.handleResize);

    // this.cityName = this.Configuration.propertyData.cityName.value;
    this.getDynamicWeather();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);

    // 移除窗口大小变化监听器
    window.removeEventListener('resize', this.handleResize);

    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    getFontSize(f = 10) {
      // 基础字体大小计算
      let baseSize = f + this.getShowfontSizeBase();

      // 屏幕宽度大于2000时，增加字体大小（增大15%）
      if (this.isLargeScreen) {
        baseSize = baseSize * 0.9;
      }

      return {
        fontSize: this.$w_Ratio(baseSize, this.$store) + 'px',
      };
    },
    // 和风天气图标代码映射到本地图标：qt(晴) dy(多云) yjdy(阴) xy(雨) xx(雪)
    getNoWeatherIcon(icon) {
      let code = Number(icon);
      let weat = 'qt';
      if (code === 104) weat = 'yjdy'; // 阴
      else if ((code >= 101 && code <= 103) || (code >= 151 && code <= 153)) weat = 'dy'; // 多云/少云
      else if (code >= 300 && code <= 399) weat = 'xy'; // 雨
      else if (code >= 400 && code <= 499) weat = 'xx'; // 雪
      else if (code === 500 || code === 501) weat = 'dy'; // 雾
      else weat = 'qt'; // 晴及其他
      return weat;
    },
    // 处理窗口大小变化
    handleResize() {
      // 使用防抖来避免频繁更新
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        // 触发重新渲染
        this.$forceUpdate();
      }, 200);
    },

    // 和风天气实时天气 https://dev.qweather.com/docs/api/weather/weather-daily-forecast/
    getDynamicWeather() {
      let nowUrl = `https://kt67cg9w3j.re.qweatherapi.com/v7/weather/now?location=${this.headerLon},${this.headerLat}&key=f17ac8b8cd2a42eea539e807cc730b16`;

      this.axios
        .get(nowUrl)
        .then(res => {
          const now = res?.data?.now || {};
          this.currTemperature = Number(now.temp) || 0;
          this.weatherIcon = now.icon || '100';
          this.weatherText = now.text || '晴';
        })
        .catch(() => {});
    },
    getStyle(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        case 'V6Style':
          style['V6' + e] = true;
          break;
        case 'V7Style':
          style['V7' + e] = true;
          break;
        case 'V8Style':
          style['V8' + e] = true;
          break;
        case 'V9Style':
          style['V9' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      console.log(ParamData, '34534534535434');

      let source = [];
      let WeatherData = [];
      let seriesList = [];
      let WeatherTheDay = [];

      if (ParamData && ParamData.source) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      console.log(source, '43534534534534535');

      // 修复数据访问，确保所有地方都使用可选链操作符
      this.humidity = source?.[0]?.hum || '44';
      this.precipitation = source?.[0]?.precipitation || '0.00';
      this.pm2point5 = source?.[0]?.PM25 || '0';
      this.windpower = source?.[0]?.windpower || '2';
      this.hPa = source?.[0]?.hPa || '1012';
      this.oxygen = source?.[0]?.oxygen || '0';
      this.temperature = source?.[0]?.DryBulTemp || source?.[0]?.y || '26';
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();

          this.setEchartsOptions(res);
          // this.loading.close();
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        // this.loading.close();
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          this.axios({
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          })
            // let param = {
            //   method: ChartsData.apiData.apiUrlMethod,
            //   url: ChartsData.apiData.apiUrl,
            //   params: this.params,
            //   headers: header,
            // };

            // request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  Configuration: {
    componentTitle: '天气卡片',
    componentName: 'Others32Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others32Charts.png',
    id: '',
    style: {
      width: 410,
      height: 244,
      left: 0,
      top: 0,
    },
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: 'rgba(0, 0, 0, 0.6)',
        lable: '头部背景颜色',
      },
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      leftSubtitle: {
        value: '实时气象数据',
        lable: '气象标题',
        propertyComponentName: 'SingleInputor',
      },
      rightSubtitle: {
        value: '温度',
        lable: '温度名称',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: [],
            source: [
              {
                hum: '44',
                precipitation: '0.00',
                hPa: '1012',
                prec: '32',
                windpower: '2',
                oxygen: '0.00',
                PM25: '0',
                DryBulTemp: '26', // 添加温度字段
                y: '26', // 兼容API返回的数据格式
              },
            ],
          },
        },
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      menuStyle: {
        value: {
          height: 85,
          width: 700,
        },
      },

      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      showStatus: {
        value: 'norm',
      },
    },
  },
};
</script>
<style scoped>
.Others32Charts {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
}
.weather-card {
  width: 100%;
  height: 100%;
  background: transparent;
  color: #fff;
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
}

/* 顶部区域样式 */
.top-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sun-icon {
  font-size: 30px;
  color: #ffd700;
  text-shadow: 0 0 15px rgba(255, 215, 0, 0.8);
}
.comfort-level {
  background-color: #010f53;

  border-radius: 12px;
  display: inline-block;
  color: #4de908;
}
.weather-status {
  display: flex;
  align-items: flex-end;
}
.weather-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 分割线 */
.divider {
  height: 2px;
  img {
    width: 100%;
    height: 1px;
  }
}

/* 底部数据区域样式 */
.bottom-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
}

.section-title {
  grid-column: 1 / 3; /* 跨3列 */
  font-weight: bolder;
  background: linear-gradient(to bottom, #feffff 0%, #aad8fc 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  padding: 4px;
  /* margin-bottom: 10px; */
}

.data-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  margin-bottom: 8px; /* 添加行间距 */
}
@media screen and (min-width: 2500px) {
  .bottom-section {
    margin-top: 5% !important;
  }
  .section-title {
    margin-bottom: 16px !important;
  }
  .data-item {
    margin-bottom: 10px !important;
  }
  .data-item .label {
    font-size: 24.59px !important;
  }
  .data-item .value {
    font-size: 24.59px !important;
  }
  .temperature {
    font-size: 40.55px !important;
  }
  .comfort-level {
    padding: 12.29px 20.25px !important;
    font-size: 28.59px !important;
  }
  .weather-info div:nth-child(1) {
    font-size: 28.25px !important;
  }
  .weather-info div:nth-child(2) {
    font-size: 30.25px !important;
  }
}
</style>
